import React, {useEffect} from 'react';
import {Dispatch, bindActionCreators} from 'redux';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {RootState} from '../../reducers';
import * as actions from '../../actions/generalActions';
import * as clientActions from '../../actions/client';
import Navbar from '../../components/Navbar/NavbarV2';
import Wrapper from '../../components/Wrapper';
import Modal from 'react-modal';
import {useHistory, withRouter} from 'react-router';
import RouterContext from '../RouterContext';
import Contacts from '../Contact/Contacts';
import Measures from '../Measures/Measures';
import Offers from '../Offers/Offers';
import Agreements from '../Agreements/Agreements';
import Production from '../Production/Production';
import Blueprints from '../Blueprints/Blueprints';
import Transport from '../Transport/Transport';
import Warehouse from '../Warehouse/Warehouse';
import Installation from '../Installation/Installation';
import Service from '../Service/Service';
import Impression from '../Impression/Impression';
import Admin from '../Admin/Admin';
import AnalyticsPageV2 from '../AnalyticsV2/AnalyticsPageV2';
import NotificationsArchivePage from '../Notifications/NotificationsArchivePage';
import NotificationSettingsPage from '../Notifications/SettingsPage';
import Page404 from '../Page404';
import "./Dashboard.scss";
import {Switch, Route, Redirect} from 'react-router-dom';
import Archive from "../Archive/Archive";
import ArchivedProducts from "../Archive/ArchivedProducts";
import {useIsMobile} from "../../hooks/useIsMobile";
import MobileNav from "../../components/MobileNav/MobileNav";

Modal.setAppElement('#root');

interface Props {
    intl: any;
    isLoading: boolean;
    setLoading: boolean;
    actions: any;
    letter: string;
    location: any;
    history: any;
    loading: boolean;
    user: any;
    match: any;
    client: any;
    clientActions: any;
    isNavOpen: boolean;
}


const Dashboard: React.FC<Props> = (props) => {

    // Reactive — flips on resize so the mobile-vs-desktop layout decision
    // re-evaluates if the user rotates, switches DevTools emulation, etc.
    // Replaces the legacy static `isMobile` const which was evaluated once
    // at module load and never updated, leaving the admin drawer stuck.
    const isMobile = useIsMobile();

    return (
        <div className={'height111vh'}>
            <div className="d-flex height111vh w-100">
                {isMobile ? (
                    // Mobile: a fixed top app bar (☰ · logo · 🔔 · avatar) plus an
                    // off-canvas drawer for navigation and an avatar account menu
                    // for language + logout. The bar is the only persistent
                    // chrome; page content sits below it (see Wrapper.scss mobile
                    // rule). Each control does one job — nav, notifications,
                    // account — with nothing duplicated across surfaces.
                    <MobileNav />
                ) : (
                    // Desktop: NavbarV2 is now the sole nav surface — the user
                    // pill, hamburger toggle, locale picker, settings, and
                    // logout all live INSIDE NavbarV2 (header at top, footer
                    // at bottom). The separate top Header strip is no longer
                    // rendered. This eliminates the misalignment between
                    // Header's wider content area and the narrower collapsed
                    // nav column, and gives mobile + desktop a consistent
                    // structural pattern.
                    <div className="navbarWrapper">
                        <Navbar />
                    </div>
                )}
                <Wrapper isNavOpen={props.isNavOpen} className="dashboard">
                    <RouterContext.Provider value={props.history}>
                        <Switch>
                            <Route path="/dashboard/observer" render={props => (<Redirect to={{
                                pathname: '/dashboard/contact',
                            }}
                            />)}/>
                            <Route path="/dashboard/contact" component={Contacts}/>
                            <Route path="/dashboard/measures" component={Measures}/>
                            <Route path="/dashboard/offers" component={Offers}/>
                            <Route path="/dashboard/agreements" component={Agreements}/>
                            <Route path="/dashboard/blueprints" component={Blueprints}/>
                            <Route path="/dashboard/production" component={Production}/>
                            <Route path="/dashboard/warehouse" component={Warehouse}/>
                            <Route path="/dashboard/transport" component={Transport}/>
                            <Route path="/dashboard/installation" component={Installation}/>
                            <Route path="/dashboard/service" component={Service}/>
                            <Route path="/dashboard/impression" component={Impression}/>
                            {/* The canonical (light-theme) Analitika hub lives in
                                containers/AnalyticsV2/. The legacy dark-theme V1
                                (containers/Analytics/, formerly at /dashboard/analytics-v2)
                                was removed 2026-06-16. */}
                            <Route path="/dashboard/analytics" component={AnalyticsPageV2}/>
                            <Route exact path="/dashboard/notifications/settings" component={NotificationSettingsPage}/>
                            <Route path="/dashboard/notifications" component={NotificationsArchivePage}/>
                            <Route path="/admin" component={Admin}/>
                            <Route component={Page404}/>
                        </Switch>
                    </RouterContext.Provider>
                </Wrapper>
            </div>
        </div>
    )
}

function mapStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
        user: state.user,
        step: state.app.step,
        client: state.client,
    }
}


function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        actions: bindActionCreators(actions as any, dispatch),
        clientActions: bindActionCreators(clientActions as any, dispatch),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Dashboard)));